module.exports = __webpack_public_path__ + "static/media/imgLoader.a52e0058.gif";